import { useQuery } from '@tanstack/react-query';

import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { RISK_ASSESSMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRiskAssessment(id?: string) {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();

  const {
    data: riskAssessment,
    isLoading: isLoadingRiskAssessment,
    isError: isErrorRiskAssessment,
    isFetched: isFetchedRiskAssessment
  } = useQuery({
    enabled: !!userBankId.length && !!id,
    queryKey: [RISK_ASSESSMENTS_KEY, userBankId, 'detail', id],
    queryFn: () => riskAssessmentsApi.getRiskAssessment(userBankId, id as string)
  });

  return { riskAssessment, isLoadingRiskAssessment, isErrorRiskAssessment, isFetchedRiskAssessment };
}
